<script setup>
import { toRef } from 'vue';
import { useChannelIcon } from './provider';
import Icon from 'next/icon/Icon.vue';

const props = defineProps({
  inbox: {
    type: Object,
    required: true,
  },
  showAvatar: {
    type: Boolean,
    default: false,
  },
});

const channelIcon = useChannelIcon(toRef(props, 'inbox'));
</script>

<template>
  <img
    v-if="showAvatar && inbox.avatar_url"
    :src="inbox.avatar_url"
    :alt="inbox.name"
    class="block rounded-full object-cover"
  />
  <Icon v-else :icon="channelIcon" />
</template>
